import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';

import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';

export const PULSE_CRM_SEARCH_GATE = 'ListingLib:useHasPulseCrmSearch';

/**
 * Gated migration of the default CRM-search REST path to Pulse.
 *
 * Takes precedence over GraphQL when ungated, so a gated consumer's default
 * (non-custom-fetcher) traffic moves onto Pulse. Custom fetchers always stay
 * on the DFC path — we don't reroute unknown fetchers through Pulse.
 *
 * Consumers that request `associationSpecs` also stay off Pulse: the
 * CrmSearchAllProperties resource does not return associated objects, which
 * features like multi-language groups depend on.
 *
 * Rollout targeting is configured in Gating Manager.
 */
export default function useHasPulseCrmSearch() {
  'use memo';
  const { fetcher, associationSpecs } = useCrmObjectType();
  const { isUngatedFor } = useUserInfo();

  const hasAssociationSpecs = Boolean(associationSpecs?.length);

  return (
    !fetcher && !hasAssociationSpecs && isUngatedFor(PULSE_CRM_SEARCH_GATE)
  );
}
